// fetching data from s3 on royalities generated and edu distributed
export async function fetchWebsiteInfo(signal) {
    try {
        const url = "https://ab1-oc-assets.s3.ap-northeast-1.amazonaws.com/web/staking/website-data.json";
        
        const res = await fetch(url, { signal })
        if(res.ok) {
            return res.json();
        } else {
            throw "Failed to fetch website info from S3";
        }
    } catch(e) {
        throw e;
    }
}